.footer {
  background: var(--bg-dark);
  color: var(--text-on-dark);
  border-top: 1px solid var(--border-on-dark);
}

.top {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 32px;
  padding-block: 44px 28px;
}
@media (max-width: 700px) {
  .top {
    grid-template-columns: 1fr;
  }
}

.logo {
  height: 34px;
  width: auto;
  /* Logo sits on a light chip so it stays legible on the dark footer without altering its colors */
  background: var(--bg-surface);
  padding: 6px 10px;
  border-radius: var(--radius-sm);
}

.brandCol p {
  margin-top: 14px;
  font-size: 0.88rem;
  color: var(--text-on-dark-soft);
  max-width: 30ch;
}

.col h4 {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--text-on-dark-soft);
  margin-bottom: 14px;
}
.col a,
.col span {
  display: block;
  font-size: 0.88rem;
  color: var(--text-on-dark-soft);
  text-decoration: none;
  margin-bottom: 9px;
}
.col a:hover {
  color: var(--text-on-dark);
}

.bottom {
  border-top: 1px solid var(--border-on-dark);
  padding-block: 18px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 0.8rem;
  color: var(--text-on-dark-soft);
}
